import { Component, OnInit } from '@angular/core';
import { WebService } from '../services/web/web.service';
import { EncryptService } from '../services/encrypt/encrypt.service';
import { DialogService } from '../services/dialog/dialog.service';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css']
})
export class AdminComponent implements OnInit {

	email:string;
	password:string;
	appname:string;
	key:string;
  isAdmin:boolean;
  isFeedbackAdmin:boolean;

  constructor(private httpService:WebService,private encryptService:EncryptService,private dialogService:DialogService) { }


  ngOnInit() {
  }

  checkValidPassword(){
    let hasNumber:boolean = false;
    let hasEightOrMore:boolean = false;
    let hasUpperCase:boolean = false;
    let hasLowerCase:boolean = false;
    hasEightOrMore = this.password.length >= 8 ? true : false;
    
    if(!hasEightOrMore){
      return false;
    }
    //console.log(this.password);
    var re = new RegExp(".*\\d+");
    var upperCaseRegex = new RegExp("[A-Z]")
    var lowercaseCaseRegex = new RegExp("[a-z]")
    if(re.test(this.password)){
          hasNumber = true;
          console.log("number");
    }
    if(upperCaseRegex.test(this.password)){
        console.log("uppercase");
        hasUpperCase = true;
    }
    if(lowercaseCaseRegex.test(this.password)){
        console.log("lowercase");
        hasLowerCase = true;
    }
    return hasUpperCase && hasLowerCase && hasNumber;

  }

  createAdmin(){
    let flag = this.checkValidPassword();
    if(!flag){
      this.dialogService.openAlert("The password should be 8 characters long,have atleast one uppercase character and atleast one number")
      .then(data=>{
            
      });
      return;
    }
    console.log("done");

  	this.encryptService.encryptPassword(this.password)
  	.then(data=>{
  		let pass = data['encrypted'];
      console.log(this.key);
  		this.httpService.getResponse('/suadminroute/createadmin',{email:this.email,password:pass,appname:this.appname.toLowerCase(),key:this.key,is_admin:this.isAdmin,is_feedbackAdmin:this.isFeedbackAdmin})
  		.then(res=>{
  			let dat = res.json();
  			if(dat['success']){
  				this.dialogService.openAlert("Admin created succesfully")
		  		.then(data=>{
		  			
		  		});
  			}else{
  				if(dat['status'] == 0){
  					this.dialogService.openAlert("Hey there!!The keys don't match.Please make sure you have access to create admins")
			  		.then(data=>{
			  			console.log(data);
			  		});
  				}else{
  					this.dialogService.openAlert(dat['err'])
			  		.then(data=>{
			  			console.log(data);
			  		});
  				}
  			}
  		})
  		.catch(err=>{
  			this.dialogService.openAlert(err.toString())
	  		.then(data=>{
	  			console.log(data);
	  		});
  		})
  	})
  	.catch(err=>{
  		
  		this.dialogService.openAlert(err.toString())
  		.then(data=>{
  			console.log(data);
  		});
  	})

  }

}



// WEBPACK FOOTER //
// ./src/app/admin/admin.component.ts